/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
import {client} from 'laravel-precognition-vue';

window.axios = axios;

const baseURL = import.meta.env.VITE_BASE_URL;

window.axios.defaults.baseURL = baseURL + '/api/';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true

window.axios.interceptors.request.use(function (config) {
  if (config.params) {
    console.log(config.params);

    // convert include array to comma separated string
    if (config.params.include){
      if (Array.isArray(config.params.include)){
        config.params.include = config.params.include.join(',');
      }
      if (!config.params.include.length){
        config.params.include = undefined;
      }
    }

    // convert each fields array to a comma separated string
    if (config.params.fields && typeof config.params.fields === 'object'){
      for (const [key, value] of Object.entries(config.params.fields)) {
        if (Array.isArray(value)){
          config.params.fields[key] = value.join(',');
        }
      }
    }
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});

client.use(window.axios);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });
